import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function PaymentReturn() {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");

  const checkSessionStatus = useCallback(
    async (sessionId) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/session_status?session_id=${sessionId}`
        );
        const data = await response.json();

        console.log("Session status data:", data);

        if (data.status === "complete") {
          setStatus("success");
          // Redirect to dashboard after 3 seconds
          const timer = setTimeout(() => {
            navigate("/dashbord");
          }, 3000);
          return () => clearTimeout(timer);
        } else {
          setStatus("failed");
        }
      } catch (error) {
        console.error("Error checking session status:", error);
        setStatus("error");
      }
    },
    [navigate]
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get("session_id");

    if (!sessionId) {
      navigate("/priser");
      return;
    }

    checkSessionStatus(sessionId);
  }, [location, navigate, checkSessionStatus]);

  if (status === "loading") {
    return <div className="payment-loading">Processing payment...</div>;
  }

  if (status === "success") {
    return (
      <div className="payment-success">
        <h2>Betaling Vellykket!</h2>
        <p>Sender deg videre...</p>
      </div>
    );
  }

  if (status === "failed" || status === "error") {
    return (
      <div className="payment-failed">
        <h2>Noe gikk galt</h2>
        <p>Betaling ble ikke gjennomført.</p>
        <button onClick={() => navigate("/priser")}>Gå tilbake</button>
      </div>
    );
  }

  return null;
}

export default PaymentReturn;
